import React from 'react';

const CrisisLifeline: React.FC = () => {
  return (
    <div className="crisis-lifeline text-white py-4">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-auto">
            <i className="fas fa-phone-alt fs-3 me-3"></i>
          </div>
          <div className="col-auto">
            <p className="mb-0 fs-5 fw-bold">
              Are you struggling with thoughts of suicide?
            </p>
          </div>
          <div className="col-auto">
            <a
              href="tel:988"
              className="btn btn-light btn-lg fw-bold"
              aria-label="Call or text the Suicide and Crisis Lifeline at 988"
            >
              Call or Text 988
            </a>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col text-center">
            <small>Suicide and Crisis Lifeline - Available 24/7</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrisisLifeline;
